import { useSearchParams } from 'react-router-dom';

/**
 * Provides current URL search params alongside a helper to remove a specific query key.
 * @returns Tuple with the current `URLSearchParams` instance and a remover function.
 */
export const useRemoveQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const removeQueryParams = (name: string) => {
    searchParams.delete(name);
    setSearchParams(searchParams);
  };

  return [searchParams, removeQueryParams] as const;
};
